import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NoviRadniNalog from './radniNalog_components/NoviRadniNalog';

const styles = {};

class RadniNalog extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <NoviRadniNalog history={this.props.history} />;
    }
}

RadniNalog.propTypes = {
    history: PropTypes.object.isRequired
};

let mapStateToProps = function(state, ownProps) {
    return {};
};

let mapDispatchToProps = function(dispatch) {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(RadniNalog);
